import game from '@/api/administrator/game-setting'

import { baseState, baseMutations } from '@/store/mixins'

export const state = {
  ...baseState
}

export const getters = {}

export const mutations = {
  ...baseMutations
}

export const actions = {
  fetch(context, attrubutes = {}) {
    let params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        search: context.state.search
      },
      attrubutes
    )
    return game.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },
  store(context, data) {
    return game.store(data)
  },
  update(context, { id, data }) {
    return game.update(id, data)
  },
  destroy(context, { id, data }) {
    return game.destroy(id, data)
  },
  async find(context, id) {
    if (_.isEmpty(context.state.edit_data)) {
      let response = await game.find(id)
      context.commit('SET_EDIT_DATA', response.data)
    }
  },
  gameType(context) {
    return game.gameType()
  }
}
